import React, { useEffect, useMemo, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { modules } from "./moduleConstants";
import "./importantDocument.css";
import { MODULE_API } from "../../apis";
import DEATH_API from "../../apis/death.api";
import { Modal, Button, Dropdown, Menu, Select, Icon } from "antd";
import NewLoader from "../../components/styled-components/loader/NewLoader";
import swal from "sweetalert";
import searchIcon from "../../assets/SVGs/magnify-glass-icon-grey.svg";
import { debounce } from "lodash";
import menuIcon from "../../assets/images/DeathModuleNew/Menu.png";
import * as Style from "../../newComponents/styledComponents/PersonalInstruction";
import copyLink from "../../assets/images/copyIconWhite.svg";
import { ToolTipCreator } from "../../helpers/ToolTipCreator";
import ModalVideo from "../ModuleVideos/ModalVideo";

const { Option } = Select;

export const ImportantDocumentMain = () => {
  const history = useHistory();
  const [moduleData, setModuleData] = useState(null);
  const [loading, setLoading] = useState(false);

  const [detailsModalData, setDetailsModalData] = useState([]);
  const [detailsModal, setDetailsModal] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);

  const [moduleModal, setModuleModal] = useState(false);
  const [selectedDocs, setSelectedDocs] = useState(null);

  const [shareModal, setShareModal] = useState(false);
  const [copied, setCopied] = useState(null);
  const [updateObject, setUpdateObject] = useState(null);
  const [timer, setTimer] = useState("");

  // OTP modal state
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userData, setUserData] = useState({});
  const [query, setQuery] = useState("");
  const [selectedTab, setSelectedTab] = useState([]);

  const latestQueryRef = useRef("");

  const debouncedSearch = useMemo(() => {
    return debounce((searchText) => {
      latestQueryRef.current = searchText; // track latest valid search
      getModuleDocs(1, searchText, true);
    }, 500);
  }, []);

  useEffect(() => {
    const normalizedQuery = query.trim().replace(/\s+/g, " ");
    latestQueryRef.current = query;

    if (normalizedQuery.trim() === "") {
      // If query is empty, cancel any pending debounced call
      debouncedSearch.cancel();
      setModuleData([]);
      getModuleDocsData(); // fetch    default list
    } else {
      setModuleData([]);
      debouncedSearch(normalizedQuery); // debounced search
    }
  }, [query]);

  const handleDocumentSelect = (name) => {
    history.push(`/orgainzer/important-document/${name}`);
  };

  const getModuleDocsData = async () => {
    try {
      setLoading(true);
      const response = await MODULE_API.fetchModulesDocsCount();

      if (response && response.data) {
        setModuleData(response.data);
      }
      setLoading(false);
    } catch (error) {
      console.log("error while getting docs list==>", error);
      setLoading(false);
    }
  };

  const getModuleDocs = async (
    page = 1,
    searchQuery = "",
    isFreshSearch = false
  ) => {
    try {
      let moduleName = "";
      // let query = "invo";
      let page = 1;
      setLoading(true);
      const docsOTP =
        userData && userData.otp
          ? userData.otp
          : localStorage.getItem("otp") && localStorage.getItem("otp");
      const response = await MODULE_API.fetchUploadedModulesDocs(
        moduleName,
        page,
        docsOTP,
        searchQuery
      );
      if (
        response &&
        response.status === 400 &&
        response.message !== "This is an expired OTP"
      ) {
        swal("Error", response.message, "error");
      }
      if (
        response &&
        response.status === 400 &&
        response.message === "This is an expired OTP"
      ) {
        swal("Error", response.message, "error");
        showModal();
      }
      if (response && response.data && response.data.rows) {
        localStorage.setItem("otp", docsOTP);
        setIsModalOpen(false);
        setDetailsModalData(response.data.rows);
        searchQuery.trim() !== "" && setDetailsModal(true);
        // Step 1: Count occurrences by type
        const typeCounts = response.data.rows.reduce((acc, item) => {
          const type = item.type;
          if (!acc[type]) {
            acc[type] = 1;
          } else {
            acc[type]++;
          }
          return acc;
        }, {});

        // Step 2: Convert to desired array format
        const result = Object.entries(typeCounts).map(([type, count]) => ({
          type,
          count,
        }));
        if (searchQuery && searchQuery.trim() !== "") {
          setModuleData(result);
        }
      }
      setLoading(false);
    } catch (error) {
      console.log("error while getting docs list==>", error);
      setLoading(false);
    }
  };

  const showModal = async () => {
    setIsModalOpen(true);
    try {
      const data = await DEATH_API.configOtp(null,"important-documents");
      if (data && data.message) {
        swal("Success", data.message, "success");
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleCancelDetailModal = () => {
    setDetailsModal(false);
    // setSelectedObject([]);
    // setCurrentTokenPage(1);
    // setTotalTokenPages(1);
    // setTotalTokenRecords(0);
    // setCurrentRecord(null);
  };

  const handleValidateOTP = async () => {
    // setLoading(true);
    // try {
    //   localStorage.setItem("otp", userData.otp);
    //   setIsModalOpen(false);
    await getModuleDocs();
    // } catch (error) {
    //   console.log(error);
    // }
    // setLoading(false);
  };

  const handleInputChange = (name, value) => {
    setUserData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCancel = () => {
    if (!localStorage.getItem("otp")) {
      localStorage.setItem("otp", "");
    }
    setIsModalOpen(false);
  };

  const resenOTP = async () => {
    try {
      const data = await DEATH_API.configOtp(null,"important-documents");
      if (data && data.message) swal("Success", data.message, "success");
    } catch (error) {
      console.log("error", error);
    }
  };

  const handelCloseShareModal = () => {
    setShareModal(false);
    setCopied(null);
    setUpdateObject(null);
    setTimer("");
  };

  const handleShareDocument = async () => {
    const data = updateObject;
    if (updateObject.fileUrl !== null) {
      try {
        setLoading(true);
        let res = await DEATH_API.createSecureLink({
          link: updateObject.fileUrl,
          fileName: updateObject.fileName,
          shareWith: "TESTER",
          time: +timer,
        });
        setLoading(false);
        setCopied(res);
        console.log("res share documnet", res);
      } catch (error) {
        console.log(error);
        throw new Error(error);
      }
    } else {
      swal("Error", "You Have No File To Share", "error");
    }
  };

  const handleClick = (link) => {
    window.open(link, "blank");
  };

  useEffect(() => {
    getModuleDocsData();
  }, []);

  useEffect(() => {
    const userRole =
      localStorage.getItem("role") !== "undefined" &&
      JSON.parse(localStorage.getItem("role"));
    const isFinancialAdvisorClient = userRole === "Financial Advisor Client";
    if (!localStorage.getItem("otp")) {
      localStorage.setItem("otp", "");
      showModal();
    } else {
      getModuleDocs();
    }
  }, []);

  const handleChange = (e) => {
    const rawInput = e.target.value;

    const sanitized = rawInput.replace(/[^a-zA-Z0-9\s]/g, "");

    // Step 2: Replace multiple spaces with one (but NOT trimming yet, to allow natural typing)
    const singleSpaced = sanitized.replace(/\s{2,}/g, " ");

    setQuery(singleSpaced);
  };

  return (
    <div className="reportsMain">
      <ModalVideo module="Important Documents" autoOpen={true} />
      <div className="imp-docs-search-filter">
        <img
          src={searchIcon}
          alt="searchNewClientIcon"
          className="search-icon"
        />
        <input
          type="text"
          name="search"
          placeholder="Search Documents..."
          value={query}
          onChange={handleChange}
          onPaste={(e) => {
            e.preventDefault();
            const pasted = e.clipboardData
              .getData("text")
              .replace(/[^a-zA-Z0-9\s]/g, "")
              .replace(/\s{2,}/g, " ");
            setQuery(pasted);
          }}
        />
        {loading && <div>Loading....</div>}
      </div>
      <div className="reportcreate" style={{ justifyContent: "space-between" }}>
        <h3 className="selectHeadingMainDocs">Important Documents</h3>
      </div>
      <div className="selectHeadingDoc">
        Select Module to add, view, edit or delete Documents
      </div>
      <div className="selectmainDocs" style={{ justifyContent: "flex-start" }}>
        {modules &&
          Object.entries(modules).map(([parentTitle, items]) => (
            <div key={parentTitle} style={{ width: "100%" }}>
              <h3 style={{ margin: "1rem 0" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    columnGap: "3px",
                  }}
                >
                  {parentTitle}
                  {parentTitle &&
                    ["organizer", "protector", "planner"].includes(
                      parentTitle.toLowerCase()
                    ) && (
                      <ToolTipCreator
                        name={
                          parentTitle === "Organizer"
                            ? "Important_Documents_Organizer"
                            : parentTitle === "Planner"
                            ? "Important_Documents_Planner"
                            : "Important_Documents_Protector"
                        }
                      />
                    )}
                </div>
              </h3>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
                {items.map((item, index) => {
                  let count = 0;

                  if (item.name === "assets") {
                    const assetMatch =
                      moduleData &&
                      moduleData.find((d) => d.type.toLowerCase() === "assets");
                    const collectionMatch =
                      moduleData &&
                      moduleData.find(
                        (d) => d.type.toLowerCase() === "collection"
                      );
                    const assetCount = (assetMatch && assetMatch.count) || 0;
                    const collectionCount =
                      (collectionMatch && collectionMatch.count) || 0;
                    count = assetCount + collectionCount;
                  } else if (item.name.toLowerCase() === "disasterdisability") {
                    const match =
                      moduleData &&
                      moduleData.find(
                        (d) => d.type.toLowerCase() === item.name.toLowerCase()
                      );
                    const matchDisatster =
                      moduleData &&
                      moduleData.find(
                        (d) => d.type.toLowerCase() === "disaster"
                      );
                    const matchDisabilty =
                      moduleData &&
                      moduleData.find(
                        (d) => d.type.toLowerCase() === "disability"
                      );
                    const disabilityCount =
                      (matchDisabilty && matchDisabilty.count) || 0;
                    const disasterCount =
                      (matchDisatster && matchDisatster.count) || 0;
                    const matchCount = (match && match.count) || 0;

                    count = disabilityCount + disasterCount + matchCount;
                  } else {
                    const match =
                      moduleData &&
                      moduleData.find(
                        (d) => d.type.toLowerCase() === item.name.toLowerCase()
                      );
                    count = (match && match.count) || 0;
                  }

                  const isOtpMissing =
                    !localStorage.getItem("otp") ||
                    localStorage.getItem("otp") === "";
                  const isSearchActive = query.trim() !== "";
                  const isCardDisabled =
                    (isSearchActive && count === 0) || isOtpMissing;

                  return (
                    <div
                      key={index}
                      onClick={() =>
                        !isCardDisabled && handleDocumentSelect(item.name)
                      }
                      className="selectMaincardsDocs"
                      style={{
                        cursor: isCardDisabled ? "not-allowed" : "pointer",
                        pointerEvents: isCardDisabled ? "none" : "auto",
                        opacity: isCardDisabled ? 0.5 : 1,
                      }}
                    >
                      <div className="selectMaincardsDocsInner">
                        <div className="selectMainImagesDocs">
                          <img
                            src={item.image}
                            height={"40px"}
                            alt={item.title}
                          />
                        </div>
                        <div className="selectMaincardsDocs-counts">
                          <div className="selectMainHeaderDocs">
                            <span className="selectheadingValueDocs">
                              {item.title}
                            </span>
                          </div>
                          <div className="selectheadingValueDocs">
                            {count} {count === 1 ? "item" : "items"}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
      </div>

      {/* OTP Modal */}
      <Modal visible={isModalOpen} footer={null} closable={false} centered>
        <h3
          className="modaltitle"
          style={{ color: "#4d5e80", marginBottom: "10px" }}
        >
          Important Documents
        </h3>
        <div>
          <h2
            className="otp-heading"
            style={{ color: "#4d5e80", marginBottom: "10px" }}
          >
            This passcode provides another layer of security for your important
            documents. The passcode is only valid for this session.
          </h2>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Enter OTP</h3>
            <input
              className="roleInput"
              placeholder="***OTP***"
              name="otp"
              onChange={(e) => handleInputChange(e.target.name, e.target.value)}
            />
          </div>
          <Button onClick={resenOTP}>Resend OTP</Button>
          <div className="buttonsMain">
            <button className="cancelbutton" onClick={handleCancel}>
              Cancel
            </button>
            <button className="savebutton" onClick={handleValidateOTP}>
              Save
            </button>
          </div>
        </div>
        <NewLoader isLoading={loading} />
      </Modal>
      {/* Details Modal */}
      <Modal
        visible={detailsModal}
        footer={null}
        onOk={handleCancelDetailModal}
        onCancel={handleCancelDetailModal}
        closable={false}
        centered
      >
        <h3 className="modaltitle">Documents Detail</h3>
        <h3 className="modaltitle">
          {detailsModalData && detailsModalData.length > 0
            ? `${detailsModalData.length} ${
                detailsModalData.length === 1 ? "Document" : "Documents"
              }`
            : "0 Documents"}
        </h3>

        <div>
          <div
            className=""
            style={{ height: "18rem", maxHeight: "18rem", overflow: "auto" }}
            id="transactions-main"
            // onScroll={handleScroll}
          >
            <NewLoader isLoading={loading} />
            {detailsModalData && detailsModalData.length > 0 ? (
              <table id="clients">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Type</th>
                    <th
                      // onClick={() => handleSort("amount")}
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody style={{}}>
                  {detailsModalData &&
                    detailsModalData.map((data, index) => (
                      <tr key={index}>
                        <td>
                          {data.fileName ? (
                            <a
                              href={data.fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {data.fileName.length > 10
                                ? `${data.fileName.slice(0, 15)}...`
                                : data.fileName}
                            </a>
                          ) : (
                            "N/A"
                          )}
                        </td>
                        <td>{data.type ? data.type : "N/A"}</td>
                        <td>
                          {/* <div style={{ display: "flex" }} key={index}>
                            <div
                              onClick={() => {
                              //   if(userRole){
                                  setSelectedItemId(data.id);
                                  setDropdown(!dropdown);
                              //   }
                              }}
                              style={{
                                cursor: "pointer",
                                marginRight: "1rem",
                                padding: "0px 16px",
                                width: "5px",
                              }}
                            >
                              <img src={menuIcon} alt="menuIcon" height={15} width={4}></img>{" "}
                            </div>
                            {dropdown && selectedItemId === data.id  && (
                              <React.Fragment>
                                <div
                                  onClick={() => {
                                    setDropdown(false);
                                  }}
                                  className="hee"
                                  style={{
                                    position: "fixed",
                                    width: "100vw",
                                    height: "100vh",
                                    background: "black",
                                    opacity: "0.1",
                                    top: "0",
                                    left: "0",
                                    right: "0",
                                    bottom: "0",
                                    zIndex: "999",
                                  }}
                                ></div>

                                <div class="dropdown" style={{ zIndex: "9999", width:"14%"}}>
                                  <ul className="dropdownul">
                                    <li
                                      className="liHover"
                                      // onClick={() => {
                                      //   setDropdown(false);
                                      //   props.handleHistoryOpen(record.id);
                                      // }}
                                    >
                                      History
                                    </li>
                                    <li
                                      className="liHover"
                                      // style={{opacity :record.ruleId !== null ? "0.3" : "1", cursor: record.ruleId!==null ? "not-allowed" : "pointer", pointerEvents: record.ruleId!==null ? "none" : "",}}
                                      // onClick={() => {
                                      //   setDropdown(false);
                                      //   props.handleOpen();
                                      //   handleFormDataUpdate(record);
                                      // }}
                                    >
                                      Update
                                    </li>

                                    <li
                                      className="liHover"
                                      // onClick={() => {
                                      //   setDropdown(false);
                                      //   props.deleteTransaction(record.id);
                                      // }}
                                    >
                                      Delete
                                    </li>
                                  </ul>
                                </div>
                              </React.Fragment>
                            )}{" "}
                          </div> */}
                          <Dropdown
                            trigger={["click"]}
                            overlay={
                              <Menu>
                                <Menu.Item>
                                  <div
                                    onClick={() => {
                                      setShareModal(true);
                                      setUpdateObject(data);
                                    }}
                                  >
                                    Share
                                  </div>
                                </Menu.Item>
                                <Menu.Item>
                                  <div
                                    onClick={() => {
                                      if (data.fileUrl) {
                                        handleClick(data.fileUrl);
                                      }
                                    }}
                                  >
                                    View
                                  </div>
                                </Menu.Item>
                              </Menu>
                            }
                          >
                            <a
                              className="ant-dropdown-link"
                              style={{ padding: "0px 8px" }}
                              onClick={(e) => e.preventDefault()}
                            >
                              <img
                                className="imgIcon"
                                src={menuIcon}
                                height={15}
                                width={4}
                                alt="icon"
                              ></img>
                            </a>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            ) : (
              <h3 className="inputTitle">
                {loading ? "Fetching Documnet..." : "No Documents to Show"}
              </h3>
            )}
          </div>
        </div>

        <div className="buttonsMain" style={{ justifyContent: "center" }}>
          <button
            className="savebutton"
            onClick={() => {
              handleCancelDetailModal();
            }}
          >
            Close
          </button>
        </div>
      </Modal>
      {/* Share Modal */}
      {shareModal && (
        <Modal visible={shareModal} footer={null} closable={false} centered>
          <div>
            <Icon
              type="close"
              style={{
                cursor: "pointer",
                fontSize: "20px",
                color: "#2a3da3",
                float: "right",
              }}
              onClick={() => {
                handelCloseShareModal();
              }}
            />
            <h4 style={{ color: "#4d5e80", marginBottom: "10px" }}>
              {" "}
              {copied && copied.preSignedUrl
                ? "Secure Link Created"
                : "Share Document Name Using Secure Link"}
            </h4>

            <div className="">
              <div>
                {copied && copied.preSignedUrl ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Style.Input
                        style={{ width: "70%" }}
                        value={copied && copied.preSignedUrl}
                        disabled={true}
                      ></Style.Input>
                      <Style.SaveButton
                        style={{ width: "20%", height: "42px" }}
                        onClick={() => {
                          navigator.clipboard.writeText(copied.preSignedUrl);
                          console.log("cooppues");
                          handelCloseShareModal();
                          swal("Success", "Copied", "success");
                        }}
                      >
                        <img
                          src={copyLink}
                          alt="copy"
                          height={25}
                          width={30}
                        ></img>
                      </Style.SaveButton>
                    </div>
                    {copied && copied.preSignedUrl && (
                      <Style.WrapperButtons>
                        <Style.CancelButton
                          onClick={() => {
                            handelCloseShareModal();
                          }}
                        >
                          Cancel
                        </Style.CancelButton>
                        <Style.SaveButton
                          onClick={() => {
                            navigator.clipboard.writeText(copied.preSignedUrl);
                            console.log("cooppues");
                            handelCloseShareModal();
                            swal("Success", "Copied", "success");
                          }}
                        >
                          Done
                        </Style.SaveButton>
                      </Style.WrapperButtons>
                    )}
                  </div>
                ) : (
                  <>
                    <div
                      style={{
                        color: "#4d5e80",
                        marginBottom: "10px",
                        fontFamily: "Poppins",
                      }}
                    >
                      {" "}
                      Secure Link becomes inactive (expires) after:
                    </div>
                    <Select
                      showSearch
                      placeholder="-Select-"
                      onChange={(value) => {
                        console.log("value", value);
                        setTimer(value);
                      }}
                    >
                      <Option value="3600">One Hour</Option>
                      <Option value="86400">One Day</Option>
                      <Option value="604800">One Week</Option>
                    </Select>
                  </>
                )}
                {copied && copied.preSignedUrl ? null : (
                  <Style.WrapperButtons>
                    <Style.CancelButton
                      onClick={() => {
                        handelCloseShareModal();
                      }}
                    >
                      Cancel
                    </Style.CancelButton>
                    <Style.SaveButton
                      onClick={() => {
                        handleShareDocument();
                      }}
                    >
                      Create Link
                    </Style.SaveButton>
                  </Style.WrapperButtons>
                )}
              </div>
            </div>
          </div>
          <NewLoader isLoading={loading} />
        </Modal>
      )}
    </div>
  );
};
